import { Link } from "react-router-dom";
import { Clock, ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

interface MagazineHeroArticleProps {
  title: string;
  excerpt: string;
  author: string;
  readTime: number;
  image: string;
  category: string;
  slug: string;
}

export const MagazineHeroArticle = ({
  title,
  excerpt,
  author,
  readTime,
  image,
  category,
  slug,
}: MagazineHeroArticleProps) => {
  return (
    <Link to={`/article/${slug}`} className="block group">
      <div className="relative h-[600px] overflow-hidden rounded-lg">
        {/* Image with overlay */}
        <div
          className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105"
          style={{ backgroundImage: `url(${image})` }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent" />
        
        {/* Content overlay */}
        <div className="absolute bottom-0 left-0 right-0 p-8 md:p-12 text-white">
          <Badge variant="secondary" className="mb-4 bg-white/20 text-white border-white/30 backdrop-blur-sm">
            {category}
          </Badge>
          
          <h1 className="text-4xl md:text-6xl font-bold mb-4 leading-tight">
            {title}
          </h1>
          
          <p className="text-lg md:text-xl text-white/90 mb-6 max-w-3xl leading-relaxed">
            {excerpt}
          </p>
          
          <div className="flex items-center gap-6 text-white/80 mb-6">
            <span className="font-medium">By {author}</span>
            <span className="flex items-center gap-2">
              <Clock className="h-4 w-4" />
              {readTime} min read
            </span>
          </div>
          
          <Button size="lg" className="bg-white text-black hover:bg-white/90">
            Read Article
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </div>
    </Link>
  );
};
